// import { http } from "@/libs/axios.js";
import Vue from 'vue'

const API = {
  aden: "/special/product/aden",
  ctJsrcdj: "/special/product/ct-jsrcdj",
  zhaoshang: "/special/product/zhaoshang",
  shanshui: "/special/product/mijingshanshui",

  jsrcdj_2023: 'special/product/ct-jsrcdj-2023',
  spectrum: 'special/product/spectrum',
  blueDream: 'special/product/blue-dream'

};

export function getAdenProduct() {
  return Vue.$axios.$post(API.aden);
}

export function getBlueDreamProduct() {
  return Vue.$axios.$post(API.blueDream);
}
// 
export function getCtJsrcdj() {
  return Vue.$axios.$post(API.ctJsrcdj);
}

// 海洋光谱号
export function getSpectrumDetail() {
  return Vue.$axios.$post(API.spectrum);
}

export function getZhaoshang() {
  return Vue.$axios.$post(API.zhaoshang);
}
export function getShanShui() {
  return Vue.$axios.$post(API.shanshui);
}



export function getJsrcdj2023() {
  return Vue.$axios.$post(API.jsrcdj_2023);
}
